fragment EntryReferenceFragment on EntryInterface {
  title
  uri
  slug
  sectionHandle
  typeHandle
  ... on article_Entry {
    image {
      url
      title
    }
  }
  ... on topic_Entry {
    teaserText
    image {
      url
      title
    }
  }
}
